import { Component, ErrorHandler, Input, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { LemonaidAsiakkaanSopimuskausi, SopimusPalvelupaketti } from '@lemon/core-firebase/model/kayttaja'
import { TuettuKieli } from '@lemon/core/model/common'
import { startWith, Subject, takeUntil } from 'rxjs'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'
import { PalvelukokonaisuusService } from '../_jaettu-angular/service/palvelukokonaisuus.service'

@Component({
  selector: 'app-palvelukokonaisuus',
  templateUrl: './palvelukokonaisuus.component.html',
  styleUrls: ['./palvelukokonaisuus.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakkaanPalvelukokonaisuusComponent implements OnInit, OnDestroy {
  @Input() sopimuskausi: LemonaidAsiakkaanSopimuskausi
  @Input() isOnboarding: boolean = false

  readonly asiakkaanPalvelupaketti = signal<string>(undefined)
  readonly palvelukokonaisuus = signal<string[]>(undefined)

  private _ngUnsubscribe: Subject<void> = new Subject()

  public sopimusPalvelupaketti = SopimusPalvelupaketti
  readonly onLisapalveluita = signal(false)

  constructor(
    private _translationService: LemonTranslationService,
    private _errorHandler: ErrorHandler,
    private _palvelukokonaisuusService: PalvelukokonaisuusService,
  ) {}

  ngOnInit() {
    this._translationService.currentLanguageObservable.pipe(startWith('fi' as TuettuKieli), takeUntil(this._ngUnsubscribe)).subscribe(kieli => {
      if (kieli && this.sopimuskausi) {
        this.asiakkaanPalvelupaketti.set(this._palvelukokonaisuusService.annaPalvelupaketinNimi(this.sopimuskausi.palvelupaketti, kieli))
        this.palvelukokonaisuus.set(this._palvelukokonaisuusService.annaPalvelukokonaisuus(this.sopimuskausi.palvelupaketti, kieli))
        this.onLisapalveluita.set(Object.values(this.sopimuskausi.lisapalvelut || {}).filter(value => value).length > 0)
      }
    })
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }
}
